export default __webpack_public_path__ + "static/media/crypto-generic-image.709699a8.jpg";